app.filter('fileSize',
    function() {
        return function(input) {
            return (input / 1024 / 1024).toFixed(2) + ' MB';
        };
    }
);